/** @module                             Components */

import Fieldset                         from "../../Global/Forms/Fieldset";

import { LabeledInput }                 from "../../Global/Forms/Inputs_Spread";

const 

RimSize = ( { __, state, action, loading } ) => { const 

    /** @constant fields */

    fields = [ "width", "diameter", "offset", "radius" ];

    /** @returns Size component */

    return (

        <Fieldset legend={ __ ( "rim_size" ) }>

            <div className="grid grid_template-columns-4">

            { 
            
                fields.map ( 
                    
                    ( field, index ) => 

                    <LabeledInput

                        key={ index }

                        type="number"

                        label={ __ ( field ) }
                            
                        value={ state [ field ] } 

                        action={ action }

                        name={ field }

                        disabled={ loading }
                        
                    />

                ) 
            
            }

            </div>

        </Fieldset>

    );

}

/** @exports RimSize */
 
export default RimSize;